import { Typography, Breadcrumb } from "antd";
import { Link } from "react-router-dom";

import ChevronRightIcon from "@/icons/ChevronRightIcon";

const { Text } = Typography;

const Breadcrumbs = ({ items, onNavigate }) => {
  return (
    <Breadcrumb
      separator={<ChevronRightIcon style={{ verticalAlign: "middle" }} />}
      itemRender={(route, params, routes, paths) => {
        return route.href ? (
          <Link
            to={route.href}
            onClick={(event) => onNavigate?.(route.href, event)}
          >
            {route.title}
          </Link>
        ) : route.title ? (
          <Text>{route.title}</Text>
        ) : null;
      }}
      items={items}
    />
  );
};

export default Breadcrumbs;
